import { useState } from "react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const LandingPage = () => {
  const [url, setUrl] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");
  const [savingsHint, setSavingsHint] = useState("— min saved");

  const handleUrlChange = (e) => {
    const value = e.target.value;
    setUrl(value);
    if (value.includes("youtube.com") || value.includes("youtu.be")) {
      const random = Math.floor(Math.random() * 30) + 20;
      setSavingsHint(`~${random} min saved`);
    } else {
      setSavingsHint("— min saved");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const response = await fetch(`${BACKEND_URL}/api/submit`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ youtube_url: url, email }),
      });

      if (!response.ok) {
        const data = await response.json();
        throw new Error(data.detail || "That URL didn't work. Try another.");
      }
      setSubmitted(true);
    } catch (err) {
      setError(err.message || "Something went wrong. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ 
      background: '#FAF8F5', 
      minHeight: '100vh',
      fontFamily: '"DM Sans", -apple-system, BlinkMacSystemFont, sans-serif'
    }}>
      {/* Navigation */}
      <nav style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        padding: '1.5rem 3rem',
        maxWidth: '1400px',
        margin: '0 auto'
      }}>
        <span style={{ 
          fontSize: '11px', 
          fontWeight: 500, 
          letterSpacing: '0.12em',
          color: '#1A1814'
        }}>RENDER</span>
        <span style={{ 
          fontSize: '11px', 
          color: '#8A8070',
          letterSpacing: '0.02em'
        }}>Extract the signal.</span>
      </nav>

      {/* Input Section */}
      <section style={{ 
        padding: '3rem 3rem 5rem',
        maxWidth: '600px',
        margin: '0 auto',
        textAlign: 'center'
      }}>
        <div style={{ 
          display: 'inline-block',
          background: '#1A1814',
          color: '#FAF8F5',
          padding: '6px 14px',
          borderRadius: '20px',
          fontSize: '11px',
          fontWeight: 500,
          letterSpacing: '0.04em',
          marginBottom: '2rem'
        }}>
          36 min <span style={{ color: '#C8501A' }}>→</span> 3 min
        </div>

        <h1 style={{ 
          fontFamily: '"Playfair Display", Georgia, serif',
          fontSize: 'clamp(42px, 8vw, 64px)',
          fontWeight: 400,
          lineHeight: 1.1,
          letterSpacing: '-0.01em',
          color: '#1A1814',
          marginBottom: '1.25rem'
        }}>
          Extract<br />the <em style={{ color: '#C8501A' }}>signal.</em>
        </h1>

        <p style={{ 
          fontSize: '15px',
          color: '#8A8070',
          lineHeight: 1.6,
          maxWidth: '460px',
          margin: '0 auto 2.5rem'
        }}>
          Stop living in a save now, never watch again society. Paste a YouTube URL. Get the core insight, key ideas, and exactly what to do with it — without watching the video.
        </p>

        {submitted ? (
          <div style={{ padding: '40px 0' }}>
            <p style={{ fontSize: '16px', color: '#1A1814', marginBottom: '8px' }}>
              Your brief is being rendered.
            </p>
            <p style={{ fontSize: '14px', color: '#8A8070', marginBottom: '24px' }}>
              Check your inbox in 1-2 minutes.
            </p>
            <button
              onClick={() => { setSubmitted(false); setUrl(""); setEmail(""); }}
              style={{ fontSize: '14px', color: '#8A8070', background: 'none', border: 'none', cursor: 'pointer' }}
              data-testid="render-another-btn"
            >
              Render another →
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div style={{ 
              background: '#FFFFFF',
              border: '0.5px solid #D8D4C8',
              marginBottom: '10px'
            }}>
              <div style={{ 
                display: 'flex', 
                alignItems: 'center',
                borderBottom: '0.5px solid #D8D4C8'
              }}>
                <input
                  type="text"
                  value={url}
                  onChange={handleUrlChange}
                  placeholder="Paste a YouTube URL"
                  required
                  style={{
                    flex: 1,
                    padding: '14px 16px',
                    border: 'none',
                    background: 'transparent',
                    fontSize: '14px',
                    color: '#1A1814',
                    outline: 'none'
                  }}
                  data-testid="youtube-url-input"
                />
                <span style={{ 
                  fontSize: '11px', 
                  color: '#B8B0A0',
                  paddingRight: '16px',
                  whiteSpace: 'nowrap'
                }}>{savingsHint}</span>
              </div>
              <div style={{ 
                display: 'flex', 
                alignItems: 'center'
              }}>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Where to send your brief"
                  required
                  style={{
                    flex: 1,
                    padding: '14px 16px',
                    border: 'none',
                    background: 'transparent',
                    fontSize: '14px',
                    color: '#1A1814',
                    outline: 'none'
                  }}
                  data-testid="email-input"
                />
                <span style={{ 
                  fontSize: '11px', 
                  color: '#B8B0A0',
                  paddingRight: '16px'
                }}>Email</span>
              </div>
            </div>

            <button
              type="submit"
              disabled={loading}
              style={{
                width: '100%',
                padding: '14px 24px',
                background: loading ? '#666' : '#1A1814',
                color: '#FAF8F5',
                border: 'none',
                fontSize: '14px',
                fontWeight: 500,
                cursor: loading ? 'default' : 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                transition: 'background 0.2s'
              }}
              onMouseEnter={(e) => !loading && (e.target.style.background = '#333')}
              onMouseLeave={(e) => !loading && (e.target.style.background = '#1A1814')}
              data-testid="submit-btn"
            >
              <span>{loading ? 'Rendering...' : 'Render this video'}</span>
              {!loading && <span style={{ color: '#C8501A' }}>→</span>}
            </button>

            {error && (
              <p style={{ fontSize: '13px', color: '#C8501A', marginTop: '12px' }}>{error}</p>
            )}

            <p style={{ 
              fontSize: '12px', 
              color: '#B8B0A0', 
              marginTop: '16px'
            }}>
              No account required. Brief delivered to your inbox in minutes.
            </p>
          </form>
        )}
      </section>

      {/* Editorial Strip */}
      <div style={{ 
        padding: '3rem',
        maxWidth: '680px',
        margin: '0 auto',
        borderTop: '1px solid #D8D4C8'
      }}>
        <h2 style={{ 
          fontFamily: '"Playfair Display", Georgia, serif',
          fontSize: 'clamp(22px, 4vw, 28px)',
          fontWeight: 400,
          lineHeight: 1.3,
          color: '#1A1814',
          marginBottom: '1.25rem'
        }}>
          You are not behind because you are lazy. You are behind because the format is broken.
        </h2>
        <p style={{ fontSize: '14px', color: '#6A6560', lineHeight: 1.75, marginBottom: '1rem' }}>
          A 60-minute video contains roughly four minutes of insight. The rest is pacing, repetition, and retention mechanics built for an algorithm. You already know this. You feel it every time you open a tab you saved three weeks ago.
        </p>
        <p style={{ fontSize: '14px', color: '#6A6560', lineHeight: 1.75 }}>
          Render extracts the four minutes. What arrives is the thesis, the non-obvious ideas, and exactly what to do with them. Not a summary. The signal.
        </p>
      </div>

      {/* Proof Strip */}
      <div style={{ 
        display: 'flex',
        justifyContent: 'center',
        gap: '4rem',
        padding: '2rem 3rem 3rem',
        flexWrap: 'wrap'
      }}>
        {[
          { number: '91%', label: 'avg. time saved per video' },
          { number: '3 min', label: 'avg. read time' },
          { number: '0', label: 'steps before you get value' }
        ].map((stat, i) => (
          <div key={i} style={{ textAlign: 'center' }}>
            <span style={{ 
              display: 'block',
              fontSize: '32px',
              fontWeight: 500,
              color: '#1A1814',
              letterSpacing: '-0.02em'
            }}>{stat.number}</span>
            <span style={{ 
              fontSize: '11px',
              color: '#8A8070',
              letterSpacing: '0.04em'
            }}>{stat.label}</span>
          </div>
        ))}
      </div>

      {/* Rendered Brief Section */}
      <section style={{ 
        background: '#FFFFFF',
        padding: '0 0 4rem'
      }}>
        {/* Brief Header */}
        <div style={{ 
          background: '#1A1814',
          color: '#FAF8F5',
          padding: '1rem 2rem',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '1rem'
        }}>
          <span style={{ fontSize: '12px' }}>
            <strong>Rendered Brief</strong> — this is what you receive
          </span>
          <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
            {['36 min source', '33 min saved', '3 min read'].map((pill, i) => (
              <span key={i} style={{ 
                background: i === 1 ? 'rgba(200,80,26,0.15)' : 'rgba(255,255,255,0.1)',
                color: i === 1 ? '#C8501A' : '#FAF8F5',
                padding: '4px 10px',
                borderRadius: '12px',
                fontSize: '10px',
                fontWeight: 500,
                letterSpacing: '0.02em'
              }}>{pill}</span>
            ))}
          </div>
        </div>

        {/* Video Thumbnail */}
        <div style={{ 
          maxWidth: '680px',
          margin: '0 auto',
          padding: '1.5rem 2.5rem 0'
        }}>
          <div style={{ 
            position: 'relative',
            aspectRatio: '16/9',
            background: '#1A1814',
            overflow: 'hidden',
            borderRadius: '4px'
          }}>
            <img 
              src="https://customer-assets.emergentagent.com/job_6bb01079-9fd6-4ef3-91f7-9c697537d129/artifacts/j7xpgs6r_maxresdefault.jpg"
              alt="Greg Isenberg - 23 AI Trends"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover'
              }}
            />
            <span style={{ 
              position: 'absolute',
              bottom: '8px',
              right: '8px',
              background: 'rgba(0,0,0,0.8)',
              color: '#FAF8F5',
              padding: '2px 6px',
              borderRadius: '3px',
              fontSize: '10px',
              fontWeight: 500,
              zIndex: 3
            }}>36:14</span>
          </div>
        </div>

        {/* Brief Body */}
        <div style={{ maxWidth: '680px', margin: '0 auto', padding: '2.5rem' }}>
          <p style={{ fontSize: '20px', fontWeight: 500, color: '#1A1814', marginBottom: '4px' }}>
            23 AI Trends Keeping Me Up at Night
          </p>
          <p style={{ fontSize: '13px', color: '#8A8070', marginBottom: '2rem' }}>Greg Isenberg</p>

          {/* Why This Matters */}
          <Section label="Why this matters">
            <p style={{ fontSize: '14px', color: '#4A4438', lineHeight: 1.65 }}>
              The "vibe coding" era has compressed the company creation cycle from months to minutes. As software becomes a commodity, profit shifts from selling tools to selling autonomous labor and human judgment.
            </p>
          </Section>

          {/* Core Insight */}
          <Section label="Core insight">
            <p style={{ 
              fontFamily: '"Playfair Display", Georgia, serif',
              fontStyle: 'italic',
              fontSize: '16px',
              color: '#1A1814',
              lineHeight: 1.6,
              borderLeft: '2px solid #C8501A',
              paddingLeft: '16px'
            }}>
              We are moving from the API economy to the Agent economy, where "labor-as-a-service" replaces software licenses. Success requires shifting from managing humans to orchestrating autonomous agent stacks that solve for outcomes rather than seats.
            </p>
          </Section>

          {/* Key Ideas */}
          <Section label="Key ideas">
            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <Idea 
                title="The One-Hour Company Stack"
                body="Vibe coding and agentic engineering allow founders to move from idea to first customer in under 60 minutes. Company building becomes high-volume experimental science rather than a high-stakes annual gamble."
              />
              <Idea 
                title="From SaaS to Vertical AI"
                body='SaaS captures IT budgets by selling tools for humans; Vertical AI captures labor budgets by replacing headcount in "boring" niches — insurance, logistics, legal. Outcome-based pricing is the new standard.'
                quote="A billion-dollar business will be built solely by converting legacy seat-based SaaS into outcome-based AI."
              />
              <Idea 
                title="The Scarcity Flip"
                body='As AI commoditizes content and code, value migrates to judgment, original "weirdness," and physical experience. Luxury brands will market "100% Human-Made" as a premium differentiator — the new "Organic."'
              />
              <Idea 
                title="Founder-Agent Fit"
                body="The ability to prompt, tune, and orchestrate an agentic workforce is the new founder superpower. The winning CEO of 2026 is an architect of autonomous systems, not a manager of people."
              />
            </div>
          </Section>

          {/* Contrarian Angle */}
          <Section label="Contrarian angle">
            <div style={{ 
              background: '#FAF8F5',
              padding: '16px',
              borderLeft: '2px solid #8A8070'
            }}>
              <p style={{ fontSize: '14px', color: '#4A4438', lineHeight: 1.65 }}>
                Most founders are hunting for the next AI app. The real opportunity is "Ambient Businesses" that run with zero human input. Stop building tools people use — build machines that work so you don't have to.
              </p>
            </div>
          </Section>

          {/* Putting This Into Practice */}
          <Section label="Putting this into practice">
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              {[
                'Identify a boring vertical (faxes, phone calls, manual entry) and build an agentic wedge.',
                'Shift pricing from monthly seat licenses to outcome-based success fees.',
                'Ship a validated MVP in under one day using Claude Code or equivalent.',
                'Prioritize proprietary data acquisition — the only moat LLMs cannot bridge.',
                'Lean into hyper-niche branding to escape the generic AI aesthetic.'
              ].map((text, i) => (
                <div key={i} style={{ display: 'flex', gap: '12px' }}>
                  <span style={{ 
                    fontSize: '11px',
                    fontFamily: 'monospace',
                    color: '#C8501A',
                    fontWeight: 600,
                    minWidth: '20px'
                  }}>0{i + 1}</span>
                  <span style={{ fontSize: '13px', color: '#4A4438', lineHeight: 1.55 }}>{text}</span>
                </div>
              ))}
            </div>
          </Section>

          {/* Intellectual Takeaway */}
          <Section label="Intellectual takeaway">
            <p style={{ 
              fontFamily: '"Playfair Display", Georgia, serif',
              fontStyle: 'italic',
              fontSize: '16px',
              color: '#1A1814',
              lineHeight: 1.6,
              borderLeft: '2px solid #C8501A',
              paddingLeft: '16px'
            }}>
              Value is migrating from the ability to execute to the ability to exercise creative judgment.
            </p>
          </Section>
        </div>

        {/* Brief Footer */}
        <div style={{ 
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          maxWidth: '680px',
          margin: '0 auto',
          padding: '1rem 2.5rem',
          borderTop: '1px solid #E8E4DC'
        }}>
          <span style={{ 
            fontSize: '11px',
            fontWeight: 500,
            letterSpacing: '0.08em',
            color: '#1A1814'
          }}>RENDER</span>
          <button style={{ 
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            padding: '8px 14px',
            border: '1px solid #D8D4C8',
            background: 'transparent',
            color: '#8A8070',
            fontSize: '12px',
            cursor: 'pointer'
          }}>
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
              <path d="M2 6H10M7 3L10 6L7 9" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            Share this brief
          </button>
        </div>
      </section>

      {/* Footer */}
      <footer style={{ 
        background: '#1A1814',
        color: 'rgba(250,248,245,0.7)',
        padding: '4rem 3rem 2rem'
      }}>
        <div style={{ 
          maxWidth: '1100px',
          margin: '0 auto',
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
          gap: '3rem',
          paddingBottom: '3rem',
          borderBottom: '1px solid rgba(250,248,245,0.1)'
        }}>
          <div>
            <span style={{ 
              fontSize: '12px',
              fontWeight: 500,
              letterSpacing: '0.12em',
              color: '#FAF8F5',
              display: 'block',
              marginBottom: '8px'
            }}>RENDER</span>
            <span style={{ fontSize: '12px', color: 'rgba(250,248,245,0.5)' }}>
              Extract the signal.
            </span>
          </div>
          <FooterCol title="Product" links={['How it works', 'Example briefs', 'Pricing']} />
          <FooterCol title="Company" links={['About', 'Blog', 'Changelog']} />
          <FooterCol title="Legal" links={['Privacy', 'Terms']} />
          <FooterCol title="Contact" links={['contact@daily-render.com', 'Twitter']} />
        </div>
        <div style={{ 
          maxWidth: '1100px',
          margin: '0 auto',
          paddingTop: '2rem',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '1rem'
        }}>
          <span style={{ fontSize: '11px', color: 'rgba(250,248,245,0.35)' }}>
            © 2025 Render. All rights reserved.
          </span>
          <span style={{ fontSize: '11px', color: 'rgba(250,248,245,0.35)' }}>
            Built for people who value their time.
          </span>
        </div>
      </footer>
    </div>
  );
};

const Section = ({ label, children }) => (
  <div style={{ marginBottom: '1.75rem' }}>
    <div style={{ 
      fontSize: '10px',
      fontWeight: 500,
      letterSpacing: '0.12em',
      color: '#C8501A',
      marginBottom: '10px',
      display: 'flex',
      alignItems: 'center',
      gap: '12px'
    }}>
      {label.toUpperCase()}
      <span style={{ flex: 1, height: '1px', background: '#E8E4DC' }} />
    </div>
    {children}
  </div>
);

const Idea = ({ title, body, quote }) => (
  <div>
    <span style={{ 
      display: 'block',
      fontSize: '14px',
      fontWeight: 600,
      color: '#1A1814',
      marginBottom: '4px'
    }}>{title}</span>
    <span style={{ 
      display: 'block',
      fontSize: '13px',
      color: '#6A6560',
      lineHeight: 1.55
    }}>{body}</span>
    {quote && (
      <span style={{ 
        display: 'block',
        fontSize: '12px',
        fontStyle: 'italic',
        color: '#8A8070',
        marginTop: '8px',
        paddingLeft: '12px',
        borderLeft: '1px solid #D8D4C8'
      }}>{quote}</span>
    )}
  </div>
);

const FooterCol = ({ title, links }) => (
  <div>
    <span style={{ 
      display: 'block',
      fontSize: '10px',
      fontWeight: 500,
      letterSpacing: '0.08em',
      color: 'rgba(250,248,245,0.5)',
      marginBottom: '12px'
    }}>{title.toUpperCase()}</span>
    {links.map((link, i) => (
      <a key={i} href="#" style={{ 
        display: 'block',
        fontSize: '13px',
        color: 'rgba(250,248,245,0.7)',
        textDecoration: 'none',
        marginBottom: '8px'
      }}>{link}</a>
    ))}
  </div>
);

export default LandingPage;
